/**
 * @generated SignedSource<<befabc1a6c018d1d235ce972e5c77eab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Event_participativeModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipativeModuleAuthorizations",
      "kind": "LinkedField",
      "name": "authorizations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contributionsSubmissionAuthorized",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TitleBarWithAction_resource"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SubscribeToEventButton_participativeModule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventDetails_participativeModule"
    }
  ],
  "type": "Event",
  "abstractKey": null
};

node.hash = "6786248e865f9e7231d1a83d37a8be7e";

module.exports = node;
